// 英语字母频率分布（基于英文文本分析）
export const letterDistribution = {
  'E': 12, 'A': 9, 'R': 8, 'I': 7, 'O': 7,
  'T': 6, 'N': 6, 'S': 6, 'L': 5, 'C': 4,
  'U': 3, 'D': 3, 'P': 3, 'M': 3, 'H': 3,
  'G': 2, 'B': 2, 'F': 2, 'Y': 2, 'W': 2,
  'K': 1, 'V': 1, 'X': 1, 'J': 1, 'Q': 1, 'Z': 1
};

// 字母分值（基于Scrabble规则调整）
export const letterScores = {
  'A': 1, 'B': 3, 'C': 3, 'D': 2, 'E': 1,
  'F': 4, 'G': 2, 'H': 4, 'I': 1, 'J': 8,
  'K': 5, 'L': 1, 'M': 3, 'N': 1, 'O': 1,
  'P': 3, 'Q': 10, 'R': 1, 'S': 1, 'T': 1,
  'U': 1, 'V': 4, 'W': 4, 'X': 8, 'Y': 4, 'Z': 10
};

// 生成牌组
export function generateDeck() {
  const deck = [];
  
  // 添加字母牌
  for (const [letter, count] of Object.entries(letterDistribution)) {
    for (let i = 0; i < count; i++) {
      deck.push({
        type: 'letter',
        letter,
        score: letterScores[letter],
        id: `letter_${letter}_${i}`
      });
    }
  }
  
  // 不再添加功能牌：根据产品规则，功能牌改为未来的道具栏/模式特性，这里只生成字母牌
  
  // 洗牌
  return shuffleArray(deck);
}

// Fisher-Yates 洗牌算法
function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// 发牌
export function dealCards(deck, playerCount, cardsPerPlayer = 7) {
  const hands = [];
  for (let i = 0; i < playerCount; i++) {
    hands.push(deck.slice(i * cardsPerPlayer, (i + 1) * cardsPerPlayer));
  }
  return { hands, remainingDeck: deck.slice(playerCount * cardsPerPlayer) };
}
